import React, { useRef, useState, useEffect } from "react";
import HTMLFlipBook from "react-pageflip";
import { FaFacebookF, FaLinkedinIn, FaGithub } from "react-icons/fa";
import "./PortfolioBook.css";

import coverImg from "./Images/project5.jpg";
import project1 from "./Images/project7.jpg";
import project2 from "./Images/project8.jpg";
import project3 from "./Images/project9.jpg";
import project4 from "./Images/project10.jpg";
import project5 from "./Images/project4.jpg";
import project6 from "./Images/project6.jpg";

export default function PortfolioBook() {
  const bookRef = useRef();
  const [dimensions, setDimensions] = useState({ width: 350, height: 500 });
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    const updateSize = () => {
      const screenW = window.innerWidth;
      const screenH = window.innerHeight;
      const ratio = 350 / 500;

      let width = screenW * 0.9;
      let height = width / ratio;

      if (height > screenH * 0.9) {
        height = screenH * 0.9;
        width = height * ratio;
      }

      setDimensions({ width, height });
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const pages = [
    {
      type: "cover",
      intro: "Hi, I'm Ike",
      role: "Full Stack Developer | UI/UX Designer | GRC Specialist",
    },
    {
      type: "about",
      title: "About Me",
      content: `I’m a software developer with a strong passion for building beautiful, functional, and user-centered digital experiences. With a background in design and business analysis, I bring a unique blend of creativity and analytical thinking to every project. I have a sharp eye for detail and a love for solving complex problems through clean, efficient code. I’m always exploring new technologies and continuously refining my craft. Outside of work, I enjoy spending time outdoors, experimenting with new recipes, reading, and playing football.`,
    },
    {
      type: "skills",
      title: "Skills",
      skills: [
        { name: "HTML", icon: "🔤" },
        { name: "CSS", icon: "🎨" },
        { name: "JavaScript", icon: "📜" },
        { name: "React JS", icon: "⚛️" },
        { name: "GRC", icon: "🛡️" },
        { name: "UI/UX", icon: "🖌️" },
        { name: "Agile", icon: "🏃‍♂️" },
        { name: "Project Management", icon: "📈" },
      ],
    },
    {
      type: "projects",
      title: "Projects",
      projects: [
        { title: "Pilates-physio", img: project1, desc: "A responsive website I developed using React and Node.js.", link: "https://pilates-physio-wellness.co.uk/" },
        { title: "ICSS 1994 Set", img: project2, desc: "An Alumni website I developed that allow easily updaing using wordpress.", link: "https://icss1994-2000alumni.org/" },
        { title: "Nosamax Ltd", img: project3, desc: "A portfolio dashboard for tracking personal projects.", link: "https://nosamaxconsultingltd.com/" },
        { title: "Kudee Ltd", img: project4, desc: "A task management app built with React and Firebase.", link: "https://kudeeltd.com/" },
        { title: "Project Five", img: project5, desc: "A portfolio dashboard for tracking personal projects.", link: "https://project3.com" },
        { title: "Project Six", img: project6, desc: "A task management app built with React and Firebase.", link: "https://project4.com" },
      ],
    },
    {
      type: "contact",
      title: "Get in touch",
      content: `Have a project in mind or just want to say hi? Feel free to reach out. 
      Email: ike@example.com | Phone: (+44) 0743074972`,
    },
  ];

  const onPageFlip = (e) => setCurrentPage(e.data);

  return (
    <div className="book-container">
      <button className="nav-button nav-left" onClick={() => bookRef.current.pageFlip().flipPrev()}>‹</button>
      <button className="nav-button nav-right" onClick={() => bookRef.current.pageFlip().flipNext()}>›</button>

      <HTMLFlipBook
        width={dimensions.width}
        height={dimensions.height}
        size="stretch"
        minWidth={250}
        maxWidth={500}
        minHeight={350}
        maxHeight={650}
        mobileScrollSupport={true}
        ref={bookRef}
        className="flipbook"
        showCover={true}
        onFlip={onPageFlip}
        animationDuration={700}
      >
        {pages.map((page, index) => (
          <div key={index} className={`page ${page.type}`}>
            
            {page.type === "cover" && (
              <div className="cover-container">
                <img src={coverImg} alt="Cover" className="cover-image" />
                <div className="cover-overlay">
                  <div className="cover-text-container">
                    <h1>{page.intro}</h1>
                    <p>{page.role}</p>
                    <div className="social-icons">
                      <a href="https://www.facebook.com/ikechukwu.celestine.566" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
                      <a href="https://www.linkedin.com/in/ikechukwu-celestin/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
                      <a href="https://github.com/IDCelestine" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
                    </div>
                    <div className="cover-buttons">
                      <button onClick={() => alert("Download CV")}> <a href="/my-cv.pdf" download className="cv-button">Download CV</a></button>
                      <button onClick={() => bookRef.current.pageFlip().turnToPage(4)}>Contact Me</button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {page.type === "about" && (
              <div className="about-page">
                <h2>{page.title}</h2>
                <p>{page.content}</p>
              </div>
            )}

            {page.type === "skills" && (
              <div className="skills-page">
                <h2>{page.title}</h2>
                <div className="skills-container">
                  {page.skills.map((skill, i) => (
                    <div className="skill-card" key={i}>
                      <span className="skill-icon">{skill.icon}</span>
                      <span className="skill-name">{skill.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {page.type === "projects" && (
              <div className="projects-page">
                <h2>{page.title}</h2>
                <div className="projects-container">
                  {page.projects.map((proj, i) => (
                    <a key={i} href={proj.link} target="_blank" rel="noreferrer" className="project-card">
                      <img src={proj.img} alt={proj.title} />
                      <h3>{proj.title}</h3>
                      <p>{proj.desc}</p>
                    </a>
                  ))}
                </div>
              </div>
            )}

            {page.type === "contact" && (
              <div className="contact-page">
                <h2>{page.title}</h2>
                <p>Have a project or a question? <br/><br/>
                <br />Email: idcelestine@yahoo.com<br/>
                <br/> Phone: (+44) 07309637432</p>
                <form className="contact-form">
                  <input type="text" placeholder="Name" required />
                  <input type="email" placeholder="Email" required />
                  <textarea placeholder="Message" required />
                  <button type="submit">Send</button>
                </form>
              </div>
            )}

            {/* Footer page number */}
            {page.type !== "cover" && (
              <div className="page-footer">
                {index} / {pages.length - 1}
              </div>
            )}

          </div>
        ))}
      </HTMLFlipBook>
    </div>
  );
}
